export const InsecureAppLayout = ({ children }) => children;
